import { render, staticRenderFns } from "./SalonTab.vue?vue&type=template&id=0bca0559&scoped=true&"
import script from "./SalonTab.vue?vue&type=script&lang=js&"
export * from "./SalonTab.vue?vue&type=script&lang=js&"
import style0 from "./SalonTab.vue?vue&type=style&index=0&id=0bca0559&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bca0559",
  null
  
)

export default component.exports